var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":_vm.homeGetTransition}},[(_vm.position === _vm.index)?_c('div',{staticClass:"home-news-element"},[_c('keep-alive',[_c('Banner' + _vm.banner,{tag:"component"})],1)],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }